// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"2679ea2b","720":"7dbfda51","945":"054ab67d","956":"2f5cf29a"}[chunkId] + ".chunk.js";
};